import React, { useEffect } from "react";

import { Box, Grid, Paper, Typography } from "@mui/material";
import LoginWave from "../../components/Vectors/LoginWave";
import styled from "@emotion/styled";
import LegalPerson from "./LegalPerson/LegalPerson";
import BrandLogo from "../../components/Vectors/BrandLogo";

const Signup = () => {
  const paperStyle = {
    padding: 32,
    overflow: "auto",
    width: "80vw",
    maxWidth: 460,
    margin: "0 auto",
    marginBottom: "24px",
    marginTop: "12px",
  };

  const ResponsiveLogoBox = styled("div")(({ theme }) => ({
    textAlign: "center",
    [theme.breakpoints.up("md")]: {
      paddingTop: "10vh",
    },
    [theme.breakpoints.down("md")]: {
      paddingTop: "1vh",
    },
  }));

  useEffect(() => {}, []);

  const CreateAccountSubtitle = styled(Typography)(({ theme }) => ({
    [theme.breakpoints.down("md")]: {
      fontSize: "13px",
    },
    [theme.breakpoints.up("md")]: {
      fontSize: "15px",
    },
  }));

  return (
    <React.Fragment>
      <LoginWave />
      <Box
        layout="column"
        justifyContent="center"
        alignItems="center"
        minHeight="99vh"
        style={{ width: [100, 100, 550, 550, 550], margin: "0 auto" }}
      >
        <ResponsiveLogoBox>
          <BrandLogo />
        </ResponsiveLogoBox>

        <Paper elevation={10} style={paperStyle}>
          <Grid item align="center">
            <h2>Criar conta</h2>
            <CreateAccountSubtitle>
              Tenha acesso a recursos exclusivos criando uma conta
            </CreateAccountSubtitle>
          </Grid>
          <LegalPerson />
        </Paper>
      </Box>
    </React.Fragment>
  );
};

export default Signup;
